<template>
  <page :title="$tc('device._name', 2)" size="is-xlarge">
    <div slot="page-header-right" v-if="$store.state.auth.manager.role === 'admin'">
      <b-button outlined style="width: 80px;" @click="editEnabled=true" v-if="editEnabled == false">{{$tc('edit')}}
      </b-button>
      <b-button outlined style="width: 80px;" @click="editEnabled=false" v-else>Disable</b-button>
    </div>

    <div class="box">
      <div class="mb-6">
        <div style="max-width: 450px;">
          <search-filter @filter="onFilter"></search-filter>
        </div>

        <br />

        <button class="button" type="is-info" outlined @click="checkedRows = []" :disabled="!checkedRows.length"
          v-if="checkedRows.length != 0">
          <b-icon icon="close"></b-icon>
          <span>Clear checked {{ checkedRows.length }} rows</span>
        </button>
        <b-button class="button" type="is-danger" style="margin-left: 10px;" outlined v-if="checkedRows.length != 0"
          @click="stateBotDevices(checkedRows)">Mark as Bot checked {{ checkedRows.length }} rows</b-button>
      </div>

      <b-table class="is-middle" :loading="devices.loading" :data="devices.data" :current-page="devices.current_page"
        :per-page="devices.per_page" :total="devices.total" paginated backend-pagination pagination-position="bottom"
        @page-change="page => devices.changePage(page)" :checked-rows.sync="checkedRows" checkable
        v-if="editEnabled == true">
        <template slot-scope="props">
          <b-table-column custom-key="image" width="80">
            <device-image v-if="props.row.model" :model="props.row.model" style="height: 35px; width: 35px;">
            </device-image>
          </b-table-column>

          <b-table-column label="Code">
            <router-link :to="'/devices/' + props.row.id">
              <div>{{ props.row.code }}</div>
            </router-link>
            <div class="has-text-grey">
              <span>{{ props.row.manufacturer }} {{ props.row.model }}</span>
              <span v-if="props.row.state != 'active'" class="tag is-danger">{{ props.row.state }}</span>
            </div>
          </b-table-column>

          <b-table-column :label="$tc('user._name')" centered>
            <router-link :to="'/users/' + user.id" v-for="user in props.row.users" :key="user.id"
              style="margin-right: 5px;">
              <b-tooltip :label="user.name">
                <div class="image is-32x32">
                  <img :src="user.profile_picture.sm" class="is-rounded" />
                </div>
              </b-tooltip>
            </router-link>
          </b-table-column>

          <b-table-column :label="$tc('dropdown.country')" width="160">
            <country-flag v-if="props.row.ip_based_country_code" :country-code="props.row.ip_based_country_code"
              with-country-name></country-flag>
          </b-table-column>

          <b-table-column :label="$tc('ip')" centered>
            <a :href="'http://ip-api.com/#' + props.row.ipv4" target="_blank">
              <small>{{ props.row.ipv4 }}</small>
            </a>
          </b-table-column>

          <b-table-column :label="$tc('device.OS')" centered>
            <div class="has-text-grey">
              <div>{{ props.row.os }}</div>
              <span>{{ props.row.os_version_number }}</span>
            </div>
          </b-table-column>

          <b-table-column :label="$tc('device.version')" centered>
            <div class="has-text-grey">
              <div>{{ props.row.app_version }}</div>
            </div>
          </b-table-column>

          <b-table-column :label="$tc('device.usage')" centered>
            <div class="has-text-grey">{{ props.row.opens_count }}</div>
          </b-table-column>

          <b-table-column :label="$tc('download_name')" centered>
            <div class="has-text-grey">{{ props.row.downloads_count }}</div>
          </b-table-column>

          <b-table-column :label="$tc('dater.created')" centered>
            <div class="has-text-grey">{{ props.row.created_at }}</div>
          </b-table-column>
        </template>

        <template slot="empty">
          <empty-message></empty-message>
        </template>
      </b-table>
      <b-table class="is-middle" :loading="devices.loading" :data="devices.data" :current-page="devices.current_page"
        :per-page="devices.per_page" :total="devices.total" paginated backend-pagination pagination-position="bottom"
        @page-change="page => devices.changePage(page)" v-else>
        <template slot-scope="props">
          <b-table-column custom-key="image" width="80">
            <device-image v-if="props.row.model" :model="props.row.model" style="height: 35px; width: 35px;">
            </device-image>
          </b-table-column>

          <b-table-column label="Code">
            <router-link :to="'/devices/' + props.row.id">
              <div>{{ props.row.code }}</div>
            </router-link>

            <div class="has-text-grey">
              <span>{{ props.row.manufacturer }} {{ props.row.model }}</span>
              <span v-if="props.row.state != 'active'" class="tag is-danger">{{ props.row.state }}</span>
            </div>
          </b-table-column>

          <b-table-column :label="$tc('user._name')" centered>
            <router-link :to="'/users/' + user.id" v-for="user in props.row.users" :key="user.id"
              style="margin-right: 5px;">
              <b-tooltip :label="user.name">
                <div class="image is-32x32">
                  <img :src="user.profile_picture.sm" class="is-rounded" />
                </div>
              </b-tooltip>
            </router-link>
          </b-table-column>

          <b-table-column :label="$tc('dropdown.country')" width="160">
            <country-flag v-if="props.row.ip_based_country_code" :country-code="props.row.ip_based_country_code"
              with-country-name></country-flag>
          </b-table-column>

          <b-table-column :label="$tc('ip')" centered>
            <a :href="'http://ip-api.com/#' + props.row.ipv4" target="_blank">
              <small>{{ props.row.ipv4 }}</small>
            </a>
          </b-table-column>

          <b-table-column :label="$tc('device.OS')" centered>
            <div class="has-text-grey">
              <div>{{ props.row.os }}</div>
              <span>{{ props.row.os_version_number }}</span>
            </div>
          </b-table-column>

          <b-table-column :label="$tc('device.version')" centered>
            <div class="has-text-grey">
              <div>{{ props.row.app_version }}</div>
            </div>
          </b-table-column>

          <b-table-column :label="$tc('device.usage')" centered>
            <div class="has-text-grey">{{ props.row.opens_count }}</div>
          </b-table-column>

          <b-table-column :label="$tc('download._name')" centered>
            <div class="has-text-grey">{{ props.row.downloads_count }}</div>
          </b-table-column>

          <b-table-column :label="$tc('dater.registered')" centered>
            <div class="has-text-grey">{{ props.row.created_at }}</div>
          </b-table-column>
        </template>

        <template slot="empty">
          <empty-message></empty-message>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
import EmptyMessage from "./../../../../components/EmptyMessage";
import CountryFlag from "@/components/CountryFlag";
import DeviceImage from "../../../../components/DeviceImage";
import SearchFilter from "../../components/filters/device/Index";

export default {
  components: {
    EmptyMessage,
    DeviceImage,
    SearchFilter,
    CountryFlag
  },
  props: {
    whenCreated: {
      type: Function
    }
  },
  data() {
    return {
      devices: new window.PaginatedRemoteCollection(
        "/admin/api/devices"
      ).load(),
      editEnabled: false,
      checkedRows: [],
      type: null
    };
  },
  watch: {
    type() {
      if (this.ignoreTypeChangeOnce) {
        return (this.ignoreTypeChangeOnce = false);
      }
      this.devices.filter({ type: this.type }).load();
    }
  },

  methods: {
    onFilter(filters) {
      this.devices = new window.PaginatedRemoteCollection("/admin/api/devices")
        .with(filters)
        .load();
    },
    stateBotDevices(checkedRows) {
      var counted = checkedRows.length;
      this.$buefy.dialog.confirm({
        title: "Are you sure?",
        message: "Changing selected " + counted + " devices to bot.",
        cancelText: "Cancel",
        confirmText: "Yes, change it",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          for (var i = 0; i < counted; i++) {
            if (i < counted - 1) {
              new window.Form({
                state: "bot"
              }).put(`/admin/api/devices/${checkedRows[i].id}`);
            } else {
              new window.Form({
                state: "bot"
              })
                .put(`/admin/api/devices/${checkedRows[i].id}`)
                .then(this.updatedToBot(counted));
            }
          }
        }
      });
    },
    updatedToBot(counted) {
      this.devices.load();
      this.checkedRows = [];
      this.$buefy.toast.open(counted + " Devices updated to Bot");
    }
  }
};
</script>
